export default __webpack_public_path__ + "static/logo-94792d09e5f0cebb674b22c023041d7c.png";